import { Scenarios } from '@jfs/network'

const getConsentsMock = {
  default: [
    {
      url: /customer\/consent/,
      method: 'POST',
      response: {
        responseCode: '00',
        responseMessage: 'SUCCESS',
        consentData: {
          consents: [
            {
              text1:
                'I hereby provide my consent to Jio Payments Bank Limited ("Bank")to use my Aadhaar number and biometric authentication to verify my identity for the purpose of initiating the AePS transactions on behalf of customers. I agree that the terms & conditions of the business correspondent services agreement executed by me with the Bank shall be applicable for providing services to the consumer. I hereby give my consent to receive promotional content on behalf of the Bank.',
              status: 'ACTIVE',
              fromDate: '2023-03-08',
              toDate: '2030-10-24',
              activityType: 'AE_PSATXNS',
              consentTextCode: 'B89',
              mandatory: 'Y',
              salesChannel: {
                id: 'Z005',
              },
            },
            {
              text1:
                'I hereby provide my consent to Jio Payments Bank Limited ("Bank") to use my Aadhaar number and biometric authentication to verify my identity for the purpose of doing AePS transactions from my account ("Service"). JPB has informed me that my biometrics will not be stored/shared and will be submitted to CIDR only for the purpose of authentication. I have reviewed the transaction details and found to be correct. I understand and agree to the terms and conditions governing the Service as available on website www.jiopaymentsbank.com and confirm that my biometric authentication be treated as my consent for availing the Service from the Bank. I hereby give my consent to receive promotional consent on behalf of the Bank.',
              status: 'ACTIVE',
              fromDate: '2023-03-08',
              toDate: '2030-10-24',
              activityType: 'AE_PSCTXNS_BI',
              consentTextCode: 'B88',
              mandatory: 'Y',
              salesChannel: {
                id: 'Z005',
              },
            },
            {
              text1:
                'I hereby provide my consent to Jio Payments Bank Limited ("Bank") to use my Aadhaar number and biometric authentication to verify my identity for the purpose of doing AePS transactions from my account ("Service"). JPB has informed me that my biometrics will not be stored/shared and will be submitted to CIDR only for the purpose of authentication. I have reviewed the transaction details and found to be correct. I understand and agree to the terms and conditions governing the Service as available on website www.jiopaymentsbank.com and confirm that my biometric authentication be treated as my consent for availing the Service from the Bank. I hereby give my consent to receive promotional consent on behalf of the Bank.',
              status: 'ACTIVE',
              fromDate: '2023-03-08',
              toDate: '2030-10-24',
              activityType: 'AE_PSCTXNS_CD',
              consentTextCode: 'B88',
              mandatory: 'Y',
              salesChannel: {
                id: 'Z005',
              },
            },
            {
              text1:
                'I hereby provide my consent to Jio Payments Bank Limited ("Bank") to use my Aadhaar number and biometric authentication to verify my identity for the purpose of doing AePS transactions from my account ("Service"). JPB has informed me that my biometrics will not be stored/shared and will be submitted to CIDR only for the purpose of authentication. I have reviewed the transaction details and found to be correct. I understand and agree to the terms and conditions governing the Service as available on website www.jiopaymentsbank.com and confirm that my biometric authentication be treated as my consent for availing the Service from the Bank. I hereby give my consent to receive promotional consent on behalf of the Bank.',
              status: 'ACTIVE',
              fromDate: '2023-03-08',
              toDate: '2030-10-24',
              activityType: 'AE_PSCTXNS_CW',
              consentTextCode: 'B88',
              mandatory: 'Y',
              salesChannel: {
                id: 'Z005',
              },
            },
            {
              text1:
                'I hereby provide my consent to Jio Payments Bank Limited ("Bank") to use my Aadhaar number and biometric authentication to verify my identity for the purpose of doing AePS transactions from my account ("Service"). JPB has informed me that my biometrics will not be stored/shared and will be submitted to CIDR only for the purpose of authentication. I have reviewed the transaction details and found to be correct. I understand and agree to the terms and conditions governing the Service as available on website www.jiopaymentsbank.com and confirm that my biometric authentication be treated as my consent for availing the Service from the Bank. I hereby give my consent to receive promotional consent on behalf of the Bank.',
              status: 'ACTIVE',
              fromDate: '2023-03-08',
              toDate: '2030-10-24',
              activityType: 'AE_PSCTXNS_FT',
              consentTextCode: 'B88',
              mandatory: 'Y',
              salesChannel: {
                id: 'Z005',
              },
            },
            {
              text1:
                'I hereby state & undertake that I have no objection in authenticating myself with Aadhaar based Authentication system and hereby give my voluntary consent as required under the Aadhaar Act 2016 and Regulations framed there under for seeding my Aadhaar number to my bank account& to provide my identity information (Aadhaar number, biometric information & demographic information) for Aadhaar based authentication for the purpose of availing of the banking services including operation of account & for delivery of subsidies, benefits, and services or any other facility relating to banking operations',
              status: 'ACTIVE',
              fromDate: '2023-03-08',
              toDate: '2030-10-24',
              activityType: 'AE_PSCTXNS_LA',
              consentTextCode: 'B90',
              mandatory: 'Y',
              salesChannel: {
                id: 'Z005',
              },
            },
            {
              text1:
                'I hereby provide my consent to Jio Payments Bank Limited ("Bank") to use my Aadhaar number and biometric authentication to verify my identity for the purpose of doing AePS transactions from my account ("Service"). JPB has informed me that my biometrics will not be stored/shared and will be submitted to CIDR only for the purpose of authentication. I have reviewed the transaction details and found to be correct. I understand and agree to the terms and conditions governing the Service as available on website www.jiopaymentsbank.com and confirm that my biometric authentication be treated as my consent for availing the Service from the Bank. I hereby give my consent to receive promotional consent on behalf of the Bank.',
              status: 'ACTIVE',
              fromDate: '2023-03-08',
              toDate: '2030-10-24',
              activityType: 'AE_PSCTXNS_MS',
              consentTextCode: 'B88',
              mandatory: 'Y',
              salesChannel: {
                id: 'Z005',
              },
            },
            {
              text1:
                'I hereby consent to the Bank conducting my E-KYC verification and retrieving my demographic details. I also authorize the Bank to securely store your demographic data for regulatory compliance and service purposes.',
              status: 'ACTIVE',
              fromDate: '2024-10-17',
              toDate: '2024-10-17',
              activityType: 'DMR_EKYC',
              consentTextCode: 'B95',
              mandatory: 'Y',
              salesChannel: {
                id: 'Z005',
              },
            },
            {
              text1: 'I agree to pay a convenience fee of Rs 1 for the addition of the beneficiary.',
              status: 'ACTIVE',
              fromDate: '2024-05-24',
              toDate: '2024-05-24',
              activityType: 'AE_PSDMRP',
              consentTextCode: 'B93',
              mandatory: 'Y',
              salesChannel: {
                id: 'Z005',
              },
            },
            {
              text1: 'I hereby confirm that I have reviewed my beneficiary details and found them to be correct.',
              status: 'ACTIVE',
              fromDate: '2024-05-24',
              toDate: '2024-05-24',
              activityType: 'AE_PSDMRV',
              consentTextCode: 'B94',
              mandatory: 'Y',
              salesChannel: {
                id: 'Z005',
              },
            },
            {
              text1:
                'I hereby provide my consent to Jio Payments Bank Limited ("Bank") to use my Aadhaar number and biometric authentication to verify my identity for the purpose of initiating the DMT transactions.',
              status: 'ACTIVE',
              fromDate: '2024-10-17',
              toDate: '2024-10-17',
              activityType: 'DMR_AUTH',
              consentTextCode: 'B96',
              mandatory: 'Y',
              salesChannel: {
                id: 'Z005',
              },
            },
            {
              text1: 'I agree to the Terms and Conditions.',
              status: 'ACTIVE',
              fromDate: '2015-10-17',
              toDate: '2035-10-17',
              activityType: 'EKYC',
              consentTextCode: 'C00',
              mandatory: 'Y',
              salesChannel: {
                id: 'Z005',
              },
            },
          ],
        },
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /customer\/consent/,
      method: 'POST',
      responseCode: 500,
      response: { error: { code: 416, message: 'Invalid request' } },
      delay: 1000,
    },
  ],
} as Scenarios


export { getConsentsMock }
